import React from 'react';
import ReactDOM from 'react-dom';
import screenfull from 'screenfull';
import { connect, Provider } from 'react-redux';

import PlayerGlobe from './components/globe/GlobeWrapper';
import ErrorScreen from './components/errorScreen/errorScreen';
import UiOverlay from './containers/UiOverlay';
import Messages from './containers/Messages';

const kResizeDebounceDelay = 250;

export default class UI {
  globeCanvas = undefined;
  rootElement = undefined;

  _width = undefined;
  _height = undefined;
  _resizeTimeout = false;

  initialize(rootElement, store) {
    this.rootElement = rootElement;

    const PlayerComponent = connect(mapStateToProps)(Player);

    // Initialize the React DOM elements based on the root element
    ReactDOM.render(
      <Provider store={store}>
        <PlayerComponent
          rootElement={rootElement}
          setCanvasWrapper={wrapper => {
            this.globeCanvasWrapper = wrapper;
          }}
        />
      </Provider>,
      rootElement,
    );

    this.onResize(store.dispatch);
  }

  createGlobeCanvas() {
    // The last canvas added is the official "globeCanvas"
    this.globeCanvas = document.createElement('canvas');
    this.globeCanvasWrapper.appendChild(this.globeCanvas);
    return this.globeCanvas;
  }

  getCreditsContainer() {
    return document.querySelector('.creditContainer');
  }

  setFullscreen(fullscreen) {
    // for ios, change the metatag for fullscreen
    const onIOS = document.querySelector('meta[name="apple-mobile-web-app-capable"]');

    onIOS.setAttribute('content', fullscreen ? 'yes' : 'no');
    if (fullscreen) screenfull.request(this.rootElement);
    else screenfull.exit();
  }

  update(dispatch) {
    // De-bounce resize events. The onResize function will be called once the the resizing stops.
    if (this._width !== this.rootElement.clientWidth || this._height !== this.rootElement.clientHeight) {
      this._width = this.rootElement.clientWidth;
      this._height = this.rootElement.clientHeight;

      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.onResize(dispatch), kResizeDebounceDelay);
    }
  }

  onResize(dispatch) {
    dispatch({ type: 'UPDATE_WINDOW_SIZE', rootElement: this.rootElement });
  }
}

function Player(props) {
  return props.fatalError ? (
    ErrorScreen(props.fatalError)
  ) : (
    <React.Fragment>
      <PlayerGlobe setCanvasWrapper={props.setCanvasWrapper} />
      <UiOverlay rootElement={props.rootElement} />
      <Messages />
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return { fatalError: state.fatalError };
}
